import script from "./MedicalAlertCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./MedicalAlertCard.vue?vue&type=script&lang=ts&setup=true"

import "./MedicalAlertCard.vue?vue&type=style&index=0&id=11c0bd60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c0bd60"]])

export default __exports__